"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const uniqBy_1 = tslib_1.__importDefault(require("lodash/uniqBy"));
const contentQueryHelper_1 = require("../../common/contentQueryHelper");
function getAllContents(input) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        // Fetching the first batch of metrics using query and getting scrollIds
        const elasticsearchResult = yield contentQueryHelper_1.getContentsUsingQuery(input, '1m');
        // Fetching remaing batch of metrics using scroll
        const { scrollId, total, contentTypeAggregation } = elasticsearchResult;
        let { contents } = elasticsearchResult;
        let remainingDocs = total - contents.length;
        if (scrollId && remainingDocs > 0) {
            let currentElasticsearchResult;
            do {
                currentElasticsearchResult = yield contentQueryHelper_1.getContentsUsingScroll(scrollId);
                const currentContents = currentElasticsearchResult.contents;
                remainingDocs -= currentContents.length;
                contents = contents.concat(currentContents);
            } while (remainingDocs > 0);
        }
        return { total, contents: uniqBy_1.default(contents, '_id'), contentTypeAggregation };
    });
}
exports.getAllContents = getAllContents;
//# sourceMappingURL=index.js.map